export default "__VITE_ASSET__c84aa630__"